/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * FIX credential update request
 */
export interface FixCredentialUpdateRequest {
  id: number;
  username?: string;
  comment?: string;
}
